module.exports = __webpack_public_path__ + "img/wanghong.045b9a71.jpg";